/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import SaveTasks from '../../services/general/TaskCrud.api'
import { CButton, CCardTitle,  CFormInput, CFormLabel, CFormTextarea, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import {  GripVertical, LayoutPanelLeft, Plus, Trash2 } from 'lucide-react'
import { toastConfig } from '../../constants/other.config'
import toast from 'react-hot-toast'
import { AnimatePresence, motion } from 'framer-motion'
import Select from 'react-select'
import SaveBoard from '../../services/general/BoardCrud.api'
import { extractBoardsFromCrudResponse, parseCrudPayload,} from './kanban-components/boardApiUtils'
import RegisterUser from '../../services/general/register.api'
import { normalizeUserRecord } from './hrm/HRMProviderUtils'
import Pageloader from '../../components/shared/Pageloader'
import UpdateTask from './kanban-components/update-task'
import { ToastContainer } from 'react-bootstrap'
import { createDefaultKanbanColumns, normalizeKanbanColumns } from './kanban-components/kanbanStatusUtils'
import './dashboard.css'



const normalizeString = (val) => {
  if (!val) return ''
  return String(val).toLowerCase().trim()
}

const isNumericText = (value) => /^\d+$/.test(String(value ?? '').trim())

const normalizeAssignee = (assignee) => {
  if (!assignee) return []

  if (Array.isArray(assignee)) return assignee.flatMap(normalizeAssignee)

  if (typeof assignee === 'string') {
    const trimmedAssignee = assignee.trim()
    if (!trimmedAssignee) return []

    try {
      const parsed = JSON.parse(trimmedAssignee)
      return normalizeAssignee(parsed)
    } catch {
      return [{ value: trimmedAssignee, label: trimmedAssignee }]
    }
  }

  if (typeof assignee === 'object') {
    const label =
      assignee.label ||
      assignee.Username ||
      assignee.username ||
      assignee.name ||
      assignee.value ||
      assignee.UserId ||
      assignee.userId ||
      assignee.id

    return label ? [{ ...assignee, value: assignee.value || assignee.UserId || assignee.userId || assignee.id || label, label }] : []
  }

  return [{ value: String(assignee), label: String(assignee) }]
}


const applyColumnOrder = (columns = []) =>
  columns.map((column, index) => ({
    ...column,
    order: index + 1,
  }))

const DEFAULT_BOARD_COLUMNS = applyColumnOrder(createDefaultKanbanColumns())

const AdminBacklog = () => {
  const location = useLocation()
  const history = useHistory()
  const [todos, setTodos] = useState([])
  const [loading, setLoading] = useState(true)
  const [editModalVisible, setEditModalVisible] = useState(false)
  const [updateTaskId, setUpdateTaskId] = useState(null)
  const [updateTaskVisible, setUpdateTaskVisible] = useState(false)
  const [selectedBoardId, setSelectedBoardId] = useState('')
  const [showBoards, setShowBoards] = useState(false)
  const [tasks, setTasks] = useState([])
  const [assignerTask, setAssignerTask] = useState([])
  const [draggedColumnIndex, setDraggedColumnIndex] = useState(null)
  const [dragOverColumnIndex, setDragOverColumnIndex] = useState(null)
const [expandedTaskId, setExpandedTaskId] = useState(null)
const [selectedTask, setSelectedTask] = useState(null)
  const [filters, setFilters] = useState({
    date: '',
    assignee: '',
  })

  const [createBoardState, setCreateBoardState] = useState({
    id: Date.now(),
    title: '',
    description: '',
    tasks: [],
    columns: DEFAULT_BOARD_COLUMNS.map((column) => ({
      ...column,
      isSystem: column.headerText === 'Completed' || column.headerText === 'Archived',
    })),
    taskWatchers: [],
    createdBy: '',
  })
  const [editingBoardId, setEditingBoardId] = useState(null)
  const [isEditingBoard, setIsEditingBoard] = useState(false)
  const userData = JSON.parse(localStorage.getItem('user'))

  const [users, setUsers] = useState([])

 const watcherOptions = users.map((user) => ({
  value: user?.Id || user?.UserId || user?.UserID,
  label: user?.Username || user?.Email,
  userData: user,
}))

   const GetAllUsers = async () => {
    const response = await RegisterUser('', '', '', '', 'get_all')
    const allUsers = response?.d?.Users || []
    setUsers(allUsers)
  }

  
useEffect(() => {
  if (!updateTaskVisible) {
    getTask()
    getAssignerTask()
  }
}, [updateTaskVisible])

  useEffect(() => {
    GetAllUsers()
  }, [])




      const tdStyle = {
            color: '#eaeaea',
            borderBottom: '1px solid #2f2f2f',
            verticalAlign: 'middle',
          padding: '16px 24px 16px 10px',
            fontSize:'16px',
            textAlign: 'start'
        }

  const AssignedTasksColumnView = ({ tasks }) => {
  // Group tasks by status
  const groupedTasks = {
    'Open': [],
    'InProgress': [],
    'Pending': [],
    'Completed': [],
    'Closed': []
  }

  tasks?.forEach(task => {
    const status = task.status || 'Open'
    const normalizedStatus = status.toLowerCase().replace(/[^a-z]/g, '')
    
    if (normalizedStatus === 'open' || normalizedStatus === 'todo') groupedTasks['Open'].push(task)
    else if (normalizedStatus === 'inprogress' || normalizedStatus === 'progress') groupedTasks['InProgress'].push(task)
    else if (normalizedStatus === 'pending') groupedTasks['Pending'].push(task)
    else if (normalizedStatus === 'completed') groupedTasks['Completed'].push(task)
    else if (normalizedStatus === 'closed') groupedTasks['Closed'].push(task)
    else groupedTasks['Open'].push(task)
  })

  return (
    <div style={{ display: 'flex', gap: '16px', overflowX: 'auto', padding: '16px', minHeight: '400px' }}>
      {Object.entries(groupedTasks).map(([status, statusTasks]) => (
        <div key={status} style={{ 
          flex: 1, 
          minWidth: '300px',
          backgroundColor: '#1e1e1e',
          borderRadius: '12px',
          padding: '16px'
        }}>
          <div style={{ 
            fontSize: '16px', 
            fontWeight: 600, 
            marginBottom: '16px',
            paddingBottom: '12px',
            borderBottom: '2px solid #333',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            color: 'var(--ui-text-primary)'
          }}>
            <span>{status}</span>
            <span style={{ 
              backgroundColor: '#333',
              padding: '2px 8px',
              borderRadius: '12px',
              fontSize: '12px'
            }}>
              {statusTasks.length}
            </span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {statusTasks.length > 0 ? (
              statusTasks.map((task) => (
                <div
                  key={task.id}
                  onClick={() => {
                    setSelectedTask(task)
                    setUpdateTaskId(task)
                    setUpdateTaskVisible(true)
                  }}
                  style={{
                    backgroundColor: '#2a2a2a',
                    borderRadius: '8px',
                    padding: '12px',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    border: '1px solid #3a3a3a'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#353535'
                    e.currentTarget.style.transform = 'translateY(-2px)'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#2a2a2a'
                    e.currentTarget.style.transform = 'translateY(0)'
                  }}
                >
                  <div style={{ fontWeight: 500, marginBottom: '8px', fontSize: '14px', color: '#58ABFF' }}>
                    {task.title}
                  </div>
                  <div style={{ fontSize: '12px', color: '#aaa', marginBottom: '4px' }}>
                    Assigned to: {getAssigneeText(task.assignee)}
                  </div>
                  <div style={{ fontSize: '12px', color: '#aaa' }}>
                    Due: {task.dueDate ? formatDateNew(task.dueDate) : '-'}
                  </div>
                </div>
              ))
            ) : (
              <div style={{ 
                textAlign: 'center', 
                color: '#666', 
                padding: '20px',
                fontSize: '14px'
              }}>
                No tasks
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}



  const getTodos = async () => {
    try {
      const response = await SaveBoard('GET_ALL', ' ' , ' ')

      const normalizedBoards = extractBoardsFromCrudResponse(response)



      console.log("Fetched boards:", normalizedBoards, response)

      if (normalizedBoards.length) {
        setTodos((normalizedBoards))
      } else {
        setTodos([])

       
      }
    } catch (err) {
      console.error('Unexpected error loading boards:', err)
      setTodos([])
    } finally {
      setLoading(false)
    }
  }


  console.log('Current board data:', todos)

   const formatDateNew = (dateString) => {
        if (!dateString) return ''

        const makeFormatted = (date) => {
            if (Number.isNaN(date?.getTime?.())) return ''
            return new Intl.DateTimeFormat('en-US', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            }).format(date)
        }

        const normalized = String(dateString).trim()
        const parts = normalized.split('-')

        if (parts.length === 3) {
            const [first, second, third] = parts
            let iso = ''

            if (first.length === 4) {
                // YYYY-MM-DD or YYYY-M-D
                iso = `${first}-${second.padStart(2, '0')}-${third.padStart(2, '0')}`
            } else if (third.length === 4) {
                // MM-DD-YYYY or M-D-YYYY
                iso = `${third}-${first.padStart(2, '0')}-${second.padStart(2, '0')}`
            }

            if (iso) {
                const date = new Date(iso)
                if (!Number.isNaN(date.getTime())) return makeFormatted(date)
            }
        }

        const fallbackDate = new Date(normalized)
        if (!Number.isNaN(fallbackDate.getTime())) return makeFormatted(fallbackDate)

        return ''
    }
       
 const firstDefined = (...values) =>
  values.find((value) => value !== undefined && value !== null)

 const safeJsonParse = (value, fallback = []) => {
  try {
    if (value === null || value === undefined || value === '') return fallback
    if (Array.isArray(value)) return value
    if (typeof value !== 'string') return value

    return JSON.parse(value)
  } catch {
    return fallback
  }
}

const toArray = (value) => {
  const parsed = safeJsonParse(value, [])
  if (Array.isArray(parsed)) return parsed
  return parsed ? [parsed] : []
}

const parseTaskRows = (response) => {
  try {
    const parsed =
      typeof response?.d === 'string'
        ? JSON.parse(response.d)
        : response?.d || response

    if (Array.isArray(parsed?.data)) return parsed.data
    if (Array.isArray(parsed)) return parsed
  } catch (error) {
    console.error('Task response parse error:', error)
  }

  return []
}

const getCurrentUserId = () =>
  String(
    userData?.Id ??
    userData?.UserID ??
    userData?.UserId ??
    userData?.id ??
    ''
  ).trim()

const getCurrentUsername = () =>
  String(
    userData?.Username ??
    userData?.username ??
    userData?.Name ??
    userData?.name ??
    userData?.Email ??
    userData?.email ??
    ''
  ).trim()

const getUserLabel = (value) => {
  const normalizedValue = String(value ?? '').trim().toLowerCase()
  if (!normalizedValue) return ''

  const matchedUser = users.find((user) => {
    const candidates = [
      user?.Id,
      user?.UserID,
      user?.UserId,
      user?.id,
      user?.value,
      user?.Username,
      user?.username,
      user?.label,
      user?.Email,
      user?.email,
    ]

    return candidates.some((candidate) => String(candidate ?? '').trim().toLowerCase() === normalizedValue)
  })

  if (matchedUser) {
    return normalizeUserRecord(matchedUser).Name
  }

  return isNumericText(value) ? '' : String(value ?? '')
}

const getAssigneeText = (assignee) => {
  const arr = normalizeAssignee(assignee)
  return arr
    .map((a) => {
      const rawLabel =
        a.label ||
        a.Username ||
        a.username ||
        a.name ||
        a.value ||
        a.UserId ||
        ''

      return getUserLabel(rawLabel) || (isNumericText(rawLabel) ? '' : String(rawLabel).trim())
    })
    .filter(Boolean)
    .join(', ')
}

const matchesCurrentUser = (value) => {
  const currentUserId = getCurrentUserId()
  const currentUsername = normalizeString(getCurrentUsername())
  const normalizedValue = String(value ?? '').trim()
  const normalizedText = normalizeString(normalizedValue)

  return Boolean(
    normalizedValue &&
    (
      (currentUserId && normalizedValue === currentUserId) ||
      (currentUsername && normalizedText === currentUsername)
    )
  )
}

const isAssignedToCurrentUser = (task) => {
  const assignees = normalizeAssignee(task?.assignee || task?.assignedUsers || task?.AssignedUsersJson)

  return assignees.some((assignee) => {
    const candidates = [
      assignee?.UserId,
      assignee?.userId,
      assignee?.Id,
      assignee?.id,
      assignee?.value,
      assignee?.Username,
      assignee?.username,
      assignee?.label,
      assignee?.name,
    ]

    return candidates.some(matchesCurrentUser)
  })
}

const isCreatedByCurrentUser = (task) => {
  if (!getCurrentUserId() && !getCurrentUsername()) return true
  return matchesCurrentUser(task?.createdBy) || matchesCurrentUser(task?.assigner)
}

const normalizeTask = (task) => {
  const taskId = firstDefined(task?.TaskId, task?.taskId, task?.id, task?.Id)
  const boardId = firstDefined(task?.BoardId, task?.boardId, task?.BoardID)
  const createdBy = firstDefined(task?.CreatedBy, task?.createdBy, task?.CreatedById, task?.createdById)
  const title = String(firstDefined(task?.Title, task?.title, task?.TaskTitle, task?.Summary, task?.summary, '')).trim()
  const status = firstDefined(task?.Status, task?.status, 'Open')
  const statusId = firstDefined(task?.StatusId, task?.statusId, task?.StatusID)
  const assignedUsers = normalizeAssignee(
    firstDefined(
      task?.AssignedUsersJson,
      task?.assignedUsersJson,
      task?.AssignedUsers,
      task?.assignedUsers,
      task?.Assignee,
      task?.assignee,
      []
    )
  )
  const subtasks = toArray(firstDefined(task?.SubtasksJson, task?.subtasksJson, task?.subTasks, task?.subtasks, task?.subtask))

  return {
    ...task,
    id: taskId,
    taskId,
    boardId,

    title: title || (taskId ? `Task #${taskId}` : 'Untitled Task'),
    description: firstDefined(task?.Description, task?.description, ''),

    status,
    statusId,
    priority: firstDefined(task?.Priority, task?.priority, ''),

    dueDate: firstDefined(task?.DueDate, task?.dueDate, ''),
    reminderDate: firstDefined(task?.ReminderDate, task?.reminderDate, ''),

    createdBy,
    assigner: matchesCurrentUser(createdBy) ? 'Me' : getUserLabel(createdBy),
    createdDate: firstDefined(task?.CreatedDate, task?.createdDate, ''),
    updatedDate: firstDefined(task?.UpdatedDate, task?.updatedDate, ''),

    assignee: assignedUsers,
    assignedUsers,

    linkedLabs: toArray(firstDefined(task?.LinkedLabsJson, task?.linkedLabs, task?.labs)),
    linkedMedications: toArray(firstDefined(task?.LinkedMedicationsJson, task?.linkedMedications, task?.medications)),
    linkedImagings: toArray(firstDefined(task?.LinkedImagingsJson, task?.linkedImagings, task?.imagings)),

    tags: toArray(firstDefined(task?.TagsJson, task?.tags, task?.Tags)),
    comments: toArray(firstDefined(task?.CommentsJson, task?.comments, task?.Comments)),
    watchers: toArray(firstDefined(task?.WatchersJson, task?.watchers, task?.Watchers)),
    activityLogs: toArray(firstDefined(task?.ActivityLogsJson, task?.activityLogs, task?.activities, task?.logs)),
    logs: toArray(firstDefined(task?.ActivityLogsJson, task?.activityLogs, task?.activities, task?.logs)),
    files: toArray(firstDefined(task?.AttachmentsJson, task?.attachmentsJson, task?.files, task?.Files)),

    subTasks: subtasks.map((sub, index) => ({
      ...sub,
      id: sub?.id || sub?.Id || `${taskId || 'subtask'}-${index}`,
      text: sub?.text || sub?.Title || sub?.title || '',
      status: sub?.status || sub?.Status || 'To Do',
      assignee: normalizeAssignee(sub?.assignee || sub?.Assignee),
      dueDate: sub?.dueDate || sub?.DueDate || '',
      reminder: sub?.reminder || sub?.ReminderDate || '',
      priority: sub?.priority || sub?.Priority || '',
      isCompleted: sub?.isCompleted || sub?.IsCompleted || false,
      checkedBy: sub?.checkedBy || sub?.CheckedBy || '',
      createdBy: sub?.createdBy || sub?.CreatedBy || '',
    })),
    rawTask: task,
  }
}

 const getTask = async () => {
  try {
    const currentUserId = getCurrentUserId()
    const currentUsername = getCurrentUsername()
    const currentUserAssignee = currentUserId || currentUsername
      ? [{ UserId: currentUserId, Username: currentUsername, value: currentUserId || currentUsername, label: currentUsername || currentUserId }]
      : []

    const response = await SaveTasks({
      action: 'GET_BY_ASSIGNEDTOME',
      createdBy: currentUserId,
      assignedUsers: currentUserAssignee,
    })

    let normalizedTasks = parseTaskRows(response).map(normalizeTask)

    if (!normalizedTasks.length) {
      const fallbackResponse = await SaveTasks({
        action: 'GET_CREATEDBYME',
        createdBy: currentUserId,
      })
      normalizedTasks = parseTaskRows(fallbackResponse)
        .map(normalizeTask)
        .filter(isAssignedToCurrentUser)
    }

    setTasks(normalizedTasks)
  } catch (error) {
    console.error('Get task error:', error)
    setTasks([])
  }
}

const getAssignerTask = async () => {
  try {
    const currentUserId = getCurrentUserId()
    const response = await SaveTasks({
      action: 'GET_CREATEDBYME',
      createdBy: currentUserId,
    })

    const normalizedTasks = parseTaskRows(response).map(normalizeTask)
    const myCreatedTasks = normalizedTasks.filter(isCreatedByCurrentUser)

    setAssignerTask(myCreatedTasks.length ? myCreatedTasks : normalizedTasks)
  } catch (error) {
    console.error('Get assigner task error:', error)
    setAssignerTask([])
  }
}

  useEffect(() => {
    getTodos()
    getTask()
    getAssignerTask()
  }, [])

  useEffect(() => {
    if (!users.length) return
    getTask()
    getAssignerTask()
  }, [users.length])

  const reorderBoardColumn = (fromIndex, toIndex) => {
    if (
      fromIndex === null ||
      toIndex === null ||
      !Number.isInteger(fromIndex) ||
      !Number.isInteger(toIndex) ||
      fromIndex === toIndex
    ) return

    setCreateBoardState((prev) => {
      if (
        fromIndex < 0 ||
        toIndex < 0 ||
        fromIndex >= prev.columns.length ||
        toIndex >= prev.columns.length
      ) return prev

      const nextColumns = [...prev.columns]
      const [movedColumn] = nextColumns.splice(fromIndex, 1)
      nextColumns.splice(toIndex, 0, movedColumn)

      return {
        ...prev,
        columns: applyColumnOrder(nextColumns),
      }
    })
  }

  const handleColumnDragStart = (event, index) => {
    setDraggedColumnIndex(index)
    event.dataTransfer.effectAllowed = 'move'
    event.dataTransfer.setData('text/plain', String(index))
  }

  const handleColumnDrop = (event, targetIndex) => {
    event.preventDefault()
    const sourceIndex = draggedColumnIndex ?? Number(event.dataTransfer.getData('text/plain'))

    reorderBoardColumn(sourceIndex, targetIndex)
    setDraggedColumnIndex(null)
    setDragOverColumnIndex(null)
  }

  const handleColumnDragEnd = () => {
    setDraggedColumnIndex(null)
    setDragOverColumnIndex(null)
  }

  
  const handleSaveBoard = async () => {
    try {
      if (!createBoardState.title?.trim()) {
        toast.error('Board title is required', toastConfig)
        return
      }

      if (!createBoardState.columns?.length) {
        toast.error('Please add at least one column', toastConfig)
        return
      }

      const hasEmptyColumn = createBoardState.columns.some(
        (col) => !col.headerText?.trim()
      )

      if (hasEmptyColumn) {
        toast.error('Column name cannot be empty', toastConfig)
        return
      }

      const columnNames = createBoardState.columns.map((c) =>
        c.headerText.trim().toLowerCase()
      )

      const hasDuplicate = new Set(columnNames).size !== columnNames.length

      if (hasDuplicate) {
        toast.error('Column names must be unique', toastConfig)
        return
      }

      const titleToCheck = createBoardState.title.trim()
      const duplicateBoard = todos.some((board) => {
        const boardTitle = String(board?.title || board?.Title || '').toLowerCase()
        if (isEditingBoard && editingBoardId && String(board?.id) === String(editingBoardId)) {
          return false
        }
        return boardTitle === titleToCheck.toLowerCase()
      })

      if (duplicateBoard) {
        toast.error(`A board with ${titleToCheck} name already exists`, toastConfig)
        return
      }

      const normalizedColumns = applyColumnOrder(
        normalizeKanbanColumns(createBoardState.columns)
      ).map((column, index) => ({
        name: column.headerText,
        HeaderText: column.headerText,
        StatusName: column.headerText,
        keyField: column.keyField ?? index + 1,
        StatusId: column.keyField ?? index + 1,
        order: index + 1,
        wipLimit: column.wipLimit || 0,
      }))

      const members = (createBoardState.taskWatchers || [])
        .map((watcher) => {
          const watcherName = String(
            watcher?.label ||
            watcher?.Username ||
            watcher?.username ||
            watcher?.name ||
            watcher?.Email ||
            watcher?.email ||
            watcher?.value ||
            ''
          ).trim()

          const watcherIdCandidate =
            watcher?.UserID ||
            watcher?.UserId ||
            watcher?.Id ||
            watcher?.id ||
            watcher?.value

          const matchedUser = users.find((user) => {
            const userName = String(
              user?.Username ||
              user?.username ||
              user?.name ||
              user?.Email ||
              user?.email ||
              ''
            ).trim().toLowerCase()

            const userId = String(user?.UserID || user?.UserId || user?.Id || user?.id || '').trim()
            const candidateId = String(watcherIdCandidate || '').trim()

            return (candidateId && userId && candidateId === userId) || (watcherName && userName && watcherName.toLowerCase() === userName)
          })

          const resolvedRefId = String(
            matchedUser?.UserID ||
            matchedUser?.UserId ||
            matchedUser?.Id ||
            matchedUser?.id ||
            watcherIdCandidate ||
            ''
          ).trim()

          if (!resolvedRefId) return null

          return {
            ref_id: resolvedRefId,
            Id: resolvedRefId,
            name: watcherName || String(matchedUser?.Username || matchedUser?.username || ''),
            Username: watcherName || String(matchedUser?.Username || matchedUser?.username || ''),
          }
        })
        .filter(Boolean)

      const boardPayload = {
        title: titleToCheck,
        Title: titleToCheck,
        description: createBoardState.description || '',
        Description: createBoardState.description || '',
        columns: normalizedColumns,
        Columns: normalizedColumns,
        createdBy: {
          id: userData?.UserID || userData?.Id || userData?.UserId || userData?.id || 1,
          UserID: userData?.UserID || userData?.Id || userData?.UserId || userData?.id || 1,
          name: userData?.Username || userData?.username || userData?.Name || userData?.name || '',
          Username: userData?.Username || userData?.username || userData?.Name || userData?.name || '',
        },
    

      members:
  createBoardState.taskWatchers?.map((user) => ({
    ref_id: user?.value,
    UserId: user?.value,
    Username: user?.label,
  })) || [],
      }

      const apiMode = isEditingBoard && editingBoardId ? 'UPDATE' : 'INSERT'
      const response = await SaveBoard({ mode: apiMode, boardData: boardPayload, boardId: editingBoardId || null })

      const payload = parseCrudPayload(response) || {}
      const savedBoards = extractBoardsFromCrudResponse(response)
      
        console.log('Save board response:', response, boardPayload)

        if (!payload || payload?.success === false || payload?.error || !savedBoards) {
          console.error('Board save failed, response:', response, 'parsed payload:', payload)
          toast.error(payload?.message || payload?.Message || 'Failed to create board', toastConfig)
          return
        }

    
      await getTodos()
      getTask()
      setEditModalVisible(false)
      setEditingBoardId(null)
      setIsEditingBoard(false)

      setCreateBoardState({
        id: Date.now(),
        title: '',
        description: '',
        tasks: [],
        columns: DEFAULT_BOARD_COLUMNS.map((column) => ({
          ...column,
          isSystem: column.headerText === 'Completed' || column.headerText === 'Archived',
        })),
        taskWatchers: [],
      })
    } catch (error) {
      console.error(error)
      toast.error('Something went wrong', toastConfig)
    }
  }

  const filteredTasks = () => {
    let result = [...tasks]

    if (filters.assignee) {
      result = result.filter(task =>
        getAssigneeText(task.assignee)
          .toLowerCase()
          .includes(filters.assignee.toLowerCase())
      )
    }

    return result
  }

 

const statusBadge = (status) => {
  const map = {
    Completed: {
      bg: '#E2FCF0',
      color: '#1f7a3e',
      dot: '#22c55e',
    },
    Pending: {
      bg: '#FFE9EB',
      color: '#b42318',
      dot: '#f04438',
    },
    InProgress: {
      bg: '#e7f1ff',
      color: '#1d4ed8',
      dot: '#3b82f6',
    },
    Open: {
      bg: '#f1f3f5',
      color: '#495057',
      dot: '#6c757d',
    },
    Closed: {
      bg: '#e9ecef',
      color: '#212529',
      dot: '#343a40',
    },
  }

  const normalizedStatusKey = String(status || '').replace(/\s+/g, '')
  const style = map[status] || map[normalizedStatusKey] || map.Open

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '4px 10px',
        borderRadius: '999px',
        backgroundColor: style.bg,
        color: style.color,
        fontSize: '13px',
        fontWeight: 500,
      }}
    >
      <span
        style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: style.dot,
        }}
      />
      {status}
    </span>
  )
}




  const navigateToTask = (task) => {
  localStorage.setItem('selected-board-id', task.boardId)
   localStorage.setItem('selected-boards', JSON.stringify(task))  
   setSelectedTask(task)        // ✅ ADD THIS
  setUpdateTaskId(task)     // ✅ FIX
  setUpdateTaskVisible(true)
}

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const taskId = params.get('taskId')
    if (!taskId) return
    const task = [...tasks, ...assignerTask].find((item) => String(item.id) === taskId)
    if (!task) return
    navigateToTask(task)
    params.delete('taskId')
    history.replace({ ...location, search: params.toString() ? `?${params}` : '' })
  }, [location.search, tasks, assignerTask])

const TaskTableCard = ({ title, headers, data, type }) => (
<div className="task-dashboard-table-card" style={{ background: 'var(--ui-dashboard-bg)', border: '0' }}>
    <div className="card-header fw-medium task-dashboard-table-title" style ={{border:'0', fontSize: "20px", background: 'var(--ui-dashboard-bg)', color: 'var(--ui-text-primary)'}} >{title}</div>
    <div className="table-responsive" style={{ maxHeight: '280px' }}>
      <table className="table table-hover mb-0 align-middle text-start task-dashboard-table" style={{border:'0'}}>
    <thead className="sticky-top">
  <tr>
    {headers.map((h, i) => (
      <th
        key={i}
        className="text-start"
        style={{
          backgroundColor: 'var(--ui-table-header-bg, var(--ui-dashboard-surface-2))',
          color: 'var(--ui-text-primary)',
          borderColor: 'var(--ui-dashboard-border)',
          padding: "12px 20px"
        }}
      >
        {h}
      </th>
    ))}
  </tr>
</thead>
 <tbody>
  {data?.length ? (
    data.map((task, index) => {
      const subTasks = task.subTasks || []
      const isExpanded = expandedTaskId === task.id

      return (
        <React.Fragment key={task.id || task.taskId || index}>
          
          {/* MAIN ROW */}
          <tr
            style={{ cursor: 'pointer' }}
            onClick={() => navigateToTask(task)}
          >
            <td style={{ padding: "12px 20px", color: 'var(--ui-color-primary)' }}>
              {subTasks.length > 0 && (
                <span
                  onClick={(e) => {
                    e.stopPropagation()
                    setExpandedTaskId(isExpanded ? null : task.id)
                  }}
                  style={{
                    marginRight: 8,
                    cursor: 'pointer',
                    display: 'inline-block',
                    transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                    transition: '0.2s'
                  }}
                >
                  ▶
                </span>
              )}
              {task.title}
            </td>

            {/* CONDITIONAL COLUMNS */}
            {type === 'created' ? (
              <>
                <td style={{ padding: "12px 20px" }}>
                  {task.assigner || getUserLabel(task.createdBy) || 'Me'}
                </td>
                <td style={{ padding: "12px 20px" }}>
                  {getAssigneeText(task.assignee) || '-'}
                </td>
              </>
            ) : (
              <td style={{ padding: "12px 20px" }}>
                {getAssigneeText(task.assignee) || '-'}
              </td>
            )}

            <td style={{ padding: "12px 20px" }}>
              {statusBadge(task.status)}
            </td>

            <td style={{ padding: "12px 20px" }}>
              {task.dueDate ? formatDateNew(task.dueDate) : '-'}
            </td>
          </tr>

          {/* SUBTASKS */}
          {isExpanded &&
            subTasks.map((sub, i) => (
              <tr key={i} style={{ background: 'var(--ui-dashboard-bg)' }}>
                <td style={{ paddingLeft: '40px', color: 'var(--ui-text-muted)' }}>
                  {sub.text}
                </td>

                {type === 'created' ? (
                  <>
                    <td>{sub.assigner || '-'}</td>
                    <td>{getAssigneeText(sub.assignee) || '-'}</td>
                  </>
                ) : (
                  <td>{getAssigneeText(sub.assignee) || '-'}</td>
                )}

                <td>{sub.status || '-'}</td>

                <td>
                  {sub.dueDate ? formatDateNew(sub.dueDate) : '-'}
                </td>
              </tr>
            ))}
        </React.Fragment>
      )
    })
  ) : (
    <tr>
      <td colSpan={headers.length} className="text-center text-muted py-4">
        No Tasks Available
      </td>
    </tr>
  )}
</tbody>

      </table>
    </div>
  </div>
)

  if (loading)
    return (
      <div>
        <Pageloader isLoading={loading} />
      </div>
    )

  return (
    <>
      {/* <div
        style={{
          minHeight: '100vh',
          maxHeight: '100%',
        }}
        className="task-management-page p-4 gap-4 position-relative d-flex flex-column"
      > */}
        <div
  style={{ minHeight: '100vh', maxHeight: '100%', position: 'relative', overflow: 'hidden' }}
  className="task-management-page patient-theme-page patient-theme-shell dashboard-dark-theme p-4 gap-4 d-flex flex-column"
>
        <div className="task-management-header d-flex justify-content-between gap-2">
        
          <span className="d-flex align-items-center gap-2">
            <div
              className="p-2 d-flex align-items-center justify-content-center"
              onClick={() => setShowBoards((p) => !p)}
              style={{ width: '40px', height: '40px', borderRadius: '10px', backgroundColor: '#1A76D3', color: '#FFFFFF', cursor: 'pointer' }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 6C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4C18.4477 4 18 4.44772 18 5C18 5.55228 18.4477 6 19 6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 20C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18C18.4477 18 18 18.4477 18 19C18 19.5523 18.4477 20 19 20Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5 6C5.55228 6 6 5.55228 6 5C6 4.44772 5.55228 4 5 4C4.44772 4 4 4.44772 4 5C4 5.55228 4.44772 6 5 6Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5 20C5.55228 20 6 19.5523 6 19C6 18.4477 5.55228 18 5 18C4.44772 18 4 18.4477 4 19C4 19.5523 4.44772 20 5 20Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h3 className="card-title task-management-title m-0 py-0 p-0">Dashboard</h3>
          </span>

          <CButton
            color="primary"
            className='rs_btn-primary task-management-add-button'
            style={{
               borderRadius:'12px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: 'max-content',
            }}
            onClick={() => setEditModalVisible((p) => !p)}
          >
             <Plus  size={16} />
               Add Board
          </CButton>
        </div>

        <div>

             <AnimatePresence>
          {showBoards && (
            <>
              <div
                onClick={(e) => {
                  e.stopPropagation()
                  setShowBoards(!showBoards)
                }}
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  bottom: 0,
                  width: '100%',
                  height: '100%',
                  zIndex: 10,
                  background: '#6b656545',
                  display: showBoards ? 'block' : 'none',
                }}
              ></div>
              <motion.div
                initial={{
                  opacity: 0,
                  x: showBoards ? '-100%' : '0',
                }}
                animate={{
                  opacity: 1,
                  x: showBoards ? '0' : '-100%',
                }}
                className="board-sidebar"
                style={{
                  position: 'absolute',
                  overflow: 'hidden',
                  overflowY: 'auto',
                  bottom: 0,
                  left: 0,
                  translateX: showBoards ? '0' : '-100%',
                  padding: '1rem',
                  zIndex: 11,
                  height: '100%',
                  width: '300px',
                  background: 'var(--ui-dashboard-surface)',
                }}
              >
                <span
                  // href="/dashboard/AdminBacklog"
                  style={{               
                    paddingBottom: '18px!important',
                    color: 'var(--ui-text-primary)',
                    paddingTop: '10px!important',
                  }}
                  className="d-flex pb-1 align-items-center gap-2 p-2 mb-3"
                >


                 

  
                  <span style={{ lineHeight: 0 }}>
                    <LayoutPanelLeft size={20} strokeWidth={1} />
                  </span>
                  <CCardTitle
                    style={{
                      fontSize: '17px',
                      color: 'var(--ui-text-primary)',
                    }}
                    className="p-0 m-0"
                  >
                    Dashboard
                  </CCardTitle>
                </span>
                {todos.map((brd, idx) => {
                  const boardId = brd?.id || brd?.Id || brd?.boardId
                  const boardTitle =
                    brd?.title || brd?.Title || brd?.Data?.title || brd?.Data?.Title || brd?.name || brd?.Data?.name || 'Untitled board'
                  const isActive = localStorage?.getItem('selected-board-id') == boardId

                  return (
                    <motion.div key={idx} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="w-100">
                      <div
                        onClick={() => {
                          setSelectedBoardId(boardId)
                          setShowBoards(false)
                          localStorage.setItem('selected-board-id', boardId)
                          localStorage.setItem('selected-boards', JSON.stringify(brd))
                          window.location.href = `/home/kanban/${boardId}`
                        }}
                        className={`d-flex align-items-center w-100 px-3 py-2 rounded 
                                                            ${isActive ? 'fw-semibold' : ''}`}
                        style={{
                          cursor: 'pointer',
                          background: isActive ? 'rgba(14, 130, 119, 0.12)' : 'transparent',
                          transition: 'background 0.2s ease',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(14,130,119,0.08)')}
                        onMouseLeave={(e) => (e.currentTarget.style.background = isActive ? 'rgba(14,130,119,0.12)' : 'transparent')}
                      >
                        <span
                          className="text-truncate"
                          style={{
                            maxWidth: '100%',
                            fontSize: '14px',
                            color: isActive ? 'var(--ui-color-primary)' : 'var(--ui-text-secondary)',
                          }}
                          title={boardTitle}
                        >
                          {boardTitle}
                        </span>
                      </div>
                    </motion.div>
                  )
                })}
              </motion.div>
            </>
          )}
        </AnimatePresence>


        </div>
     
   
        <div className="task-management-section" style={{   borderRadius: '16px',
    overflow: 'hidden',
    background: 'var(--ui-dashboard-bg)',
    // backgroundColor: "red",
    paddingTop: "20px",
    zIndex: 9
    }}>
  <TaskTableCard
  title="Assigned Task" 
  headers={['Task', 'Assigned To', 'Status', 'Due Date']}
  data={filteredTasks()}
/>
  </div>
  <div className="task-management-section" style={{   borderRadius: '16px',
    overflow: 'hidden',
    background: 'var(--ui-dashboard-bg)',
    zIndex: 9,         
    paddingTop: "20px"}}>
  <TaskTableCard
  title="Created Task"
  headers={['Task', 'Assigned By', 'Assigned To', 'Status', 'Due Date']}
  data={assignerTask}
  type="created"
  
/>
        </div>
      </div>

      <CModal backdrop={'static'} visible={editModalVisible} onClose={() => {
          setEditModalVisible(false)
          setEditingBoardId(null)
          setIsEditingBoard(false)
        }} scrollable size="xl" className="task-jira-modal dashboard-dark-modal">
        <CModalHeader className="dashboard-dark-modal-header" style={{ border: '0', padding: '20px 24px 0' }}>
          <CModalTitle style={{ fontSize: '16px', fontWeight: 600, color: 'var(--ui-text-primary)' }}>Add Board</CModalTitle>
        </CModalHeader>
        <CModalBody className="dashboard-dark-modal-body" style={{ padding: '20px 24px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '24px' }}>
            {/* Title Section */}
            <div>
              <label style={{ fontSize: '12px', fontWeight: 600, color: '#44546F', marginBottom: '6px', display: 'block' }}>Title<span style={{ color: "red", marginLeft: '4px' }}>*</span></label>
              <CFormInput
                placeholder="Enter Board Title"
                value={createBoardState.title}
                onChange={(e) => {
                  setCreateBoardState((p) => ({
                    ...p,
                    title: e.target.value,
                  }))
                }}
                style={{
                  border: '1px solid #DFE1E6',
                  borderRadius: '6px',
                  fontSize: '13px',
                  padding: '10px 12px',
                }}
              />
            </div>

            {/* Description Section */}
            <div>
              <label style={{ fontSize: '12px', fontWeight: 600, color: '#44546F', marginBottom: '6px', display: 'block' }}>Description</label>
              <CFormTextarea
                placeholder="Enter Board Description"
                rows={4}
                value={createBoardState.description}
                onChange={(e) => {
                  setCreateBoardState((p) => ({
                    ...p,
                    description: e.target.value,
                  }))
                }}
                style={{
                  border: '1px solid #DFE1E6',
                  borderRadius: '6px',
                  fontSize: '13px',
                  padding: '10px 12px',
                  fontFamily: 'inherit',
                }}
              />
            </div>

            {/*
            <Task Watchers Section>
            <div>
              <label style={{ fontSize: '12px', fontWeight: 600, color: '#44546F', marginBottom: '6px', display: 'block' }}>Watchers</label>
              <Select
                isMulti
                options={watcherOptions}
                value={createBoardState.taskWatchers}
                onChange={(selected) => {
                  setCreateBoardState((p) => ({
                    ...p,
                    taskWatchers: selected || [],
                  }))
                }}
                placeholder="Add Watchers"
                styles={{
                  control: (base) => ({
                    ...base,
                    minHeight: '42px',
                    borderRadius: '6px',
                    border: '1px solid #DFE1E6',
                    boxShadow: 'none',
                  }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
              />
            </div>
            */}

            {/* Columns Section */}
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <label style={{ fontSize: '12px', fontWeight: 600, color: '#44546F', margin: 0 }}>Columns</label>
                <span
                  style={{
                    fontSize: '12px',
                    padding: '6px 12px',
                    color: 'var(--ui-text-primary)',
                    fontWeight: 500,
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    setCreateBoardState((p) => ({
                      ...p,
                      columns: applyColumnOrder([
                        ...p.columns,
                        {
                          name: '',
                          keyField: Date.now(),
                          order: p.columns.length + 1,
                          isCollapse: false,
                          isSystem: false,
                        },
                      ]),
                    }))
                  }}
                >
                  + Add Column
                </span>
              </div>
              <div style={{ display: 'grid', gap: '8px' }}>
                {createBoardState.columns.map((item, idx) => {
                  const isDragSource = draggedColumnIndex === idx
                  const isDropTarget = dragOverColumnIndex === idx && draggedColumnIndex !== idx

                  return (
                  <div
                    key={`${item.keyField || item.headerText}-${idx}`}
                    draggable
                    onDragStart={(event) => handleColumnDragStart(event, idx)}
                    onDragOver={(event) => {
                      event.preventDefault()
                      event.dataTransfer.dropEffect = 'move'
                    }}
                    onDragEnter={() => setDragOverColumnIndex(idx)}
                    onDrop={(event) => handleColumnDrop(event, idx)}
                    onDragEnd={handleColumnDragEnd}
                      className={`d-flex align-items-center p-1 rounded ${isDropTarget ? 'drop-target-active' : ''}`}
                      style={{
                        gap: '10px',
                        background: isDropTarget ? 'var(--ui-dashboard-surface-3, #E9F2FF)' : 'transparent',
                        opacity: isDragSource ? 0.6 : 1,
                      cursor: 'grab',
                      transition: 'background 0.15s ease, opacity 0.15s ease',
                    }}
                  >
                    <span
                      aria-hidden="true"
                      style={{
                        width: '28px',
                        height: '40px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#98A2B3',
                        cursor: 'grab',
                        flexShrink: 0,
                      }}
                    >
                      <GripVertical size={18} />
                    </span>
                    <CFormInput
                      placeholder={`Column ${idx + 1} Name`}
                      value={item.headerText}
                      onChange={(e) => {
                        setCreateBoardState((p) => ({
                          ...p,
                          columns: p.columns.map((i, j) => {
                            if (j === idx) {
                              return { ...i, headerText: e.target.value, order: j + 1 }
                            }
                            return i
                          }),
                        }))
                      }}
                      disabled={item.isSystem}
                      style={{
                        border: '1px solid #DFE1E6',
                        borderRadius: '6px',
                        fontSize: '13px',
                        padding: '10px 12px',
                        flex: 1,
                        opacity: item.isSystem ? 0.6 : 1,
                      }}
                    />
                    {!item.isSystem && (
                      <CButton
                        color="danger"
                        size="sm"
                        style={{
                          padding: '6px 18px',
                          fontSize: '16px',
                          border: 'none',
                          background: '#F87462',
                          color: 'white',
                          borderRadius: '6px',
                        }}
                        onClick={() => {
                          setCreateBoardState((p) => ({
                            ...p,
                            columns: applyColumnOrder(p.columns.filter((_, i) => i !== idx)),
                          }))
                        }}
                      >
                        Remove
                      </CButton>
                    )}
                  </div>
                  )
                })}
              </div>
            </div>
          </div>
        </CModalBody>
        <CModalFooter
          style={{
            borderTop: '1px solid var(--ui-dashboard-border-strong)',
            display: 'flex',
            justifyContent: 'center',
            gap: '0px',
            padding: '20px 24px 24px',
            background: 'var(--ui-dashboard-bg)',
          }}
        >
          <CButton
            variant="outline"
            className="rs_btn-secondary"
            style={{
              borderRadius: '12px',
              padding: '10px 24px',
              minWidth: '101px',
              width: '101px',
              backgroundColor: 'transparent',
              color: 'var(--ui-text-secondary)',
              border: 'none',
              fontSize: '16px',
            }}
            onClick={() => {
              setEditModalVisible(false)
              setEditingBoardId(null)
              setIsEditingBoard(false)
              setCreateBoardState({
                id: Date.now(),
                title: '',
                description: '',
                tasks: [],
                columns: DEFAULT_BOARD_COLUMNS.map((column) => ({
                  ...column,
                  isSystem: column.headerText === 'Completed' || column.headerText === 'Archived',
                })),
                taskWatchers: [],
              })
            }}
          >
            Close
          </CButton>
          <CButton
            color="primary"
            className="rs_btn-primary"
            style={{
              borderRadius: '12px',
              padding: '10px 24px',
              minWidth: '101px',
              width: '101px',
              fontSize: '16px',
              border: 'none',
            }}
            onClick={() => handleSaveBoard()}
          >
            Save
          </CButton>
        </CModalFooter>
      </CModal>
      <UpdateTask
        visible={updateTaskVisible}
        fetchBoard={todos}
        updateTaskId={updateTaskId}
        setUpdateTaskId={setUpdateTaskId}
        setVisible={setUpdateTaskVisible}
        breadcrumbPrevText="All Tasks"
        breadcrumbPrevHref="/home/all-tasks"
      />
    </>
  )
}

export default AdminBacklog
